import { render } from "./EasyIcon.vue?vue&type=template&id=055c5972"
import script from "./EasyIcon.vue?vue&type=script&lang=js"
export * from "./EasyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__